export const services = [
  {
    title: '지식과 인사이트 허브',
    desc: `경제, 사회, 정보 등 핵심 이슈를 빠르게\n공유하고 영업 경쟁력을 높이는 깊이 있는 대화`,
    img: '/imgs/icons/service_1.png',
  },
  {
    title: '실전 경제 인사이트',
    desc: `시장 흐름부터 소비 트렌드까지,\n비즈니스 감각을 키우는 핵심 정보`,
    img: '/imgs/icons/service_2.png',
  },
  {
    title: '트렌드 & 실시간 정보',
    desc: `변화하는 시장과 사회 흐름을 읽고\n앞서가는 영업 전략을 세울 수 있는 정보`,
    img: '/imgs/icons/service_3.png',
  },
  {
    title: '영업 정보와 노하우',
    desc: ` 영업인의 경험이 콘텐츠가 됩니다.\n노하우와 사례를 나누며 함께 성장`,
    img: '/imgs/icons/service_4.png',
  },
];

export const hubs = [
  {
    title: '비즈니스 등록',
    desc: `영업 파트너를 모집하고\n성과에 따라 리워드를 설정할 수 있어요.`,
    img: '/imgs/icons/hub_1.png',
  },
  {
    title: '비즈니스 참여',
    desc: `다양한 비즈니스 게시물에 참여하고\n성과를 내면 보상이 따라옵니다.`,
    img: '/imgs/icons/hub_2.png',
  },
  {
    title: '성과와 리워드',
    desc: `계약·가입 등 실적이 확인되면\n등록자가 리워드를 지급해요.`,
    img: '/imgs/icons/hub_3.png',
  },
  {
    title: '내가 직접 정하는 보상',
    desc: `성과 기준도, 리워드 금액도\n등록자가 직접 설정할 수 있어요.`,
    img: '/imgs/icons/hub_4.png',
  },
];
